export default {
    data(){
        return{
    en: {
      /* ===================== FOOTER_NAME ======================*/
  
        footer_name: "Rosy Nebula",
  
      /* ===================== EMAIL ======================*/
  
      footer_email: "Email ",
  
        /* ===================== PHONE NO ======================*/

      footer_phone_no: "Phone Number: ",

      /* ===================== LOCATION ======================*/
  
      footer_address: "Address：Nottingham Innovation and Entrepreneurship Building, Yinzhou, Ningbo, China ",
  
    }
  }
  }
  };
  